// const Backbone = require('backbone');
const Marionette = require('backbone.marionette');
const templates = require('../templates');
// const HeaderClubView = require('./header_club.js');
const HeaderHourView = require('./header_hour.js');
const HeaderDatesView = require('./header_dates.js');
const HeaderFiltersView = require('./header_filters.js');
const controller = require('../controllers/header.js');
const coachCommands = require('../commands/goto-coach.js');
const parameters = require('../data/parameters.js');
const app = require('../app.js');

module.exports = Marionette.LayoutView.extend({
  template: templates.header,
  initialize() {
    this.listenTo(app.vent, 'returnToDefault', this.returnToDefault);
  },
  returnToDefault() {
    this.model.get('filters').each(filter => {
      filter.set('active', false);
    });
  },
  regions: {
    header_club: '.header_top .first_block .clubname',
    header_hour: '.header_top .first_block .current_hour',
    header_dates: '.header_bottom .daysanddate_list',
    header_filters: '.header_bottom .filters'
  },
  events: {
    'click .coachLink': 'onCoachLinkClick'
  },
  onCoachLinkClick() {
    const club = this.model.get('club');
    const clientToken = parameters.get('client_token');

    coachCommands(clientToken, club.get('id'));
  },
  onBeforeShow() {
    // const club = this.model.get('club');
    // const studios = this.model.get('studios');

    // this.showChildView(
    //   'header_club',
    //   new HeaderClubView({
    //     model: new Backbone.Model({
    //       club,
    //       studios
    //     })
    //   })
    // );
    this.showChildView(
      'header_hour',
      new HeaderHourView({
        model: this.model.get('date')
      })
    );
    this.showChildView(
      'header_dates',
      new HeaderDatesView({
        collection: controller.getDatesForNumberOfWeeks(this.model.get('date'))
      })
    );

    this.showChildView(
      'header_filters',
      new HeaderFiltersView({
        collection: this.model.get('filters')
      })
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/header.js